import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getPacks } from '../../actions/packs';

// redux-form field holding a pack id ('' = no pack).
const ReduxFormPackSelect = ({ input, meta: { touched, error } }) => {
  const dispatch = useDispatch();
  const packs = useSelector((state) => state.packs.packs);

  useEffect(() => {
    dispatch(getPacks());
  }, [dispatch]);

  const options = packs.map((pack) => ({ value: pack.objectId, label: pack.name }));
  let value = options.find((option) => option.value === input.value) || null;
  // Unknown id once packs are loaded (pack deleted): show it so it can be cleared.
  if (!value && input.value && packs.length > 0) {
    value = { value: input.value, label: 'Pack supprimé' };
  }

  return (
    <>
      <Select
        value={value}
        options={options}
        isClearable
        placeholder="Sans pack"
        onChange={(option) => input.onChange(option ? option.value : '')}
        onBlur={() => input.onBlur(input.value)}
        styles={{ container: (styles) => ({ ...styles, width: '100%', marginTop: 10 }), menu: (styles) => ({ ...styles, zIndex: 100 }) }}
      />
      {touched && error && <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: 10 }}>{error}</div>}
    </>
  );
};

ReduxFormPackSelect.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default ReduxFormPackSelect;
